module.exports = __webpack_public_path__ + "static/media/LOGO RDP TRANSPARANT (1) (1).7e5d0036.png";